export default "__VITE_ASSET__8yNa2v2T__"